"use strict";

(function (global) {
  
  /**  
  * Фабрика заданий.
  * Предоставлет инструменты для работы с заданиями.
  *
  * @namespace WebAccess.factories.jobs
  * @property {OBJECT_TYPE} WebAccess.factories.jobs.contentType Тип содержимого фабрики
  * @since 5.0.0.7300
  */

  var JobsFactory = global.factories.BaseFactory.extend({
    className: "JobsFactory",

      contentType: OBJECT_TYPE.JOB,

      init: function () {
        this._super(this.contentType);
      }
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    });
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  global.factories.jobs = new JobsFactory();
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  
})(window.WebAccess);